export default __webpack_public_path__ + "static/media/announcement_5@2x.4f48ffd7.png";